import { gql } from "apollo-boost";

export const GET_ATTRIBUTEVALUES = gql`
query AttributeValues($where: AttributeValueWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  attributeValues(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    total
    data {
      id
      value
      isDeleted
      createdAt
      updatedAt
      attribute {
        id
        name
      }
      shop {
        id
        name
      }
    }
  }
}
`
